'use strict';

import angular from 'angular';
// import ngAnimate from 'angular-animate';
import ngCookies from 'angular-cookies';
import ngResource from 'angular-resource';
import ngSanitize from 'angular-sanitize';
import ngMaterial from 'angular-material';
import angularMoment from 'angular-moment';
import angularDragula from 'angularjs-dragula';

import 'angular-socket-io';
const ngRoute = require('angular-route');

import uiBootstrap from 'angular-ui-bootstrap';
import 'angular-validation-match';

import {
  routeConfig
} from './app.config';

import _Auth from '../components/auth/auth.module';
import account from './account';
import admin from './admin';
import allgroups from './admin/groups';
import passwords from './admin/passwords';
import common from '../components/common/common.service';
import notifications from '../components/notifications/notifications.service';
import groups from '../components/groups/groups.service';
import subjects from '../components/subjects/subjects.service';
import navbar from '../components/navbar/navbar.component';
import alerts from '../components/alerts/alerts.component';
import sidenav from '../components/sidenav/sidenav.component';
import footer from '../components/footer/footer.component';
import main from './main/main.component';
import closed from './closed/closed.component';
import terms from './terms/terms.component';
import group from './group/group.component';
import dashboard from './dashboard/dashboard.component';
import messages from './messages/messages.component';
import constants from './app.constants';
import util from '../components/util/util.module';
import socket from '../components/socket/socket.service';

import './app.scss';

angular.module('ffApp', [ngCookies, ngResource, ngSanitize, 'btford.socket-io', ngRoute,
  uiBootstrap, _Auth, account, admin, allgroups, passwords, 'validation.match', common, groups, subjects, navbar, alerts, sidenav, footer, main, constants,
  ngMaterial, angularMoment, dashboard, group, angularDragula(angular), messages, terms, notifications,
  socket, util, closed
]).constant('GLOBALS', {
  vno: "v 3.9.0",
  apiProtocol: "https",
  apiHost: "www.foeface.com",
  //apiProtocol: "http",
  //apiHost: "localhost:3000",
  //apiHost: "192.168.1.7:3000",
  /*apiProtocol: "https",
  apiHost: "46.101.56.143:3001",*/
  appBuild: false,
  msgLength: 4800,
  starttime: [0,0,0],
  endtime: [23,59,0]
})
  .config(routeConfig)
  .run(function($rootScope, $location, amMoment, Auth) {
    'ngInject';
    // Redirect to login if route requires auth and you're not logged in

    $rootScope.$on('$stateChangeStart', function(event, next) {
      Auth.isLoggedIn(function(loggedIn) {
        if(next.authenticate && !loggedIn) {
          $location.path('/login');
        }
      });
    });

    var currentLocale = 'en';
    amMoment.changeLocale(currentLocale, {
      calendar: {
        lastDay: '[Yesterday]',
        sameDay: '[Today]',
        nextDay: '[Tomorrow]',
        lastWeek: '[Last] dddd',
        nextWeek: 'dddd',
        sameElse: 'ddd D MMM YYYY'
      }
    });
  })
  .factory('REST_Interceptor',['GLOBALS', '$location', function(GLOBALS, $location) {
    var REST_Interceptor = {
      request: function(config) {
        config.url = GLOBALS.apiProtocol + "://" + GLOBALS.apiHost + config.url;
        return config;
      }
    }

    return REST_Interceptor;
  }]);

angular.element(document)
  .ready(() => {
    angular.bootstrap(document, ['ffApp'], {
      strictDi: true
    });
  });



// WEBPACK FOOTER //
// ./client/app/app.js